import React from 'react'

const Logo = () => {

  const LogoAgro = "images/icon/agromax.png";


  return (
    <>
    <div>
      <img src={ LogoAgro } alt="AgroMax"  style={{height:'66px', width:'170px'}} />
    </div>
    </>
  )
}

export default Logo
